import { render, staticRenderFns } from "./VersionEditor.Vue?vue&type=template&id=3f7aa927"
import script from "./VersionEditor.Vue?vue&type=script&lang=js"
export * from "./VersionEditor.Vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/VersionEditor.Vue
// module id = 218
// module chunks = 0